

export function killsliders() {
	jQuery('.slick-initialized').slick('unslick');
}
